import { BranchDesignator, CodeNext, Export, UnvalidatedCodeNext } from "@fusion-advantage/backcompat"
import { exportClientName, exportDateOfService } from "./exportInfo"
import { age, plainDateTimeSecs } from "../util"
import { DateTime } from "luxon"

// a convenience model to pass into dashboard components
// that is easier to mock up for storybook

export interface DisplayExport {
	encounterGuid: string
	codeNext: UnvalidatedCodeNext
	branchGuid: string
	branchDesignator: BranchDesignator
	dateOfService: string|null
	memberAge: number
	clientName: string|null
	lastUpdateDt: string|null
	auditorUsername: string|null
	lineOfBusiness: string|null
}

export const exportToDisplayExport = (exp: Export): DisplayExport => {
	const codeNext = exp.Form.Encounter.CodeNext
	let lastUpdateDt: string|null = null
	if(codeNext !== CodeNext.NotStarted) {
		lastUpdateDt = plainDateTimeSecs(DateTime.fromISO(exp.Form.Encounter.EncounterLastUpdateDT))
	}
	return {
		encounterGuid: exp.Form.Encounter.Encounter_GUID,
		codeNext,
		branchGuid: exp.Form.Encounter.BranchGUID,
		branchDesignator: exp.Form.Encounter.BranchDesignatorV2,
		dateOfService: exportDateOfService(exp),
		memberAge: age(DateTime.fromISO(exp.Form.Member.BirthDate)),
		clientName: exportClientName(exp),
		lastUpdateDt,
		auditorUsername: exp.Form.Encounter.Auditor_ID ?? null,
		lineOfBusiness: exp.Form.Member.ClientLOB ?? null,
	}
}
